var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans",attrs:{"id":"app"},on:{"mousemove":_vm.resetLogoutTimer}},[_c('router-view'),_c('Loader',{attrs:{"loadingMessage":'Processing'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }